<template>
  <Modal
    :title="$t('rename_version_modal_title')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${sharedCollectionHashid}/personalisations/${personalisation.hashid}` }"
    :confirm-label="$t('rename')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('name')"
      name="name"
      :description="$t('version_name_example')"
    >
      <TextInput
        v-model="form.name"
        name="name"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
const props = defineProps<{
  sharedCollectionHashid: string
  personalisation: CollectionPersonalisation
}>()

const form = reactive({
  name: props.personalisation.name
})
</script>
